import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import moment from 'moment';

import FlightReportRefuelApprovalsTab from '../../FlightReportRefuels/Elements/FlightReportRefuelApprovalsTab';
import FlightReportRefuelEditTab from '../../FlightReportRefuels/Elements/FlightReportRefuelEditTab';
import getLocale from '../../../i18n/getLocale';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class FlightReportRefuelTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: false,
      modal: false,
      approval_required: 0,
      export_required: 0,
      flight_report_id: this.props.flight_report_id,
      fuel_type: this.props.fuel_type,
      fuel_type_id: this.props.fuel_type_id,
      fuel_unity: this.props.fuel_unity,
      flight_report_legs_select: this.props.flight_report_legs_select,
      fuel_suppliers_select: this.props.fuel_suppliers_select,
      ptbr_fuels_select: this.props.ptbr_fuels_select,
      flight_report_refuels: this.props.flight_report_refuels,
      flight_report_refuel_edit: {},
      companies_select: this.props.companies_select,
      fuel_types_select: this.props.fuel_types_select,
      staffs_select: this.props.staffs_select,
      flight_report_leg_id: null,
    };

    //bind específico
    this.add = this.add.bind(this);
    this.delete = this.delete.bind(this);
    this.openEditModal = this.openEditModal.bind(this);
    this.closeModal = this.closeModal.bind(this);

    // Handlers
    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleChangeDate (name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      var date = event.target.value;
      var year  = date.split("-")[0];
      var month  = date.split("-")[1];
      var day  = date.split("-")[2];
      change[name] = date;
    }
    this.setState(change);
  }
  handleSelectChangeFuelType(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
      
      if(navigator.onLine) {
        var header = this.refs.request_api.header('application/json');
        var self = this;
        self.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/tipo/combustivel/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({
              fuel_type: responseJson.data.abbreviation,
            });
            self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
        
    }
    this.setState(change);
  }
  
  handleChangeGallonsReading (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
    
    if (name == 'reading_start') {
      var start = event.target.value;
    } else {
      var start = this.state.reading_start;
    }
    if (name == 'reading_finish') {
      var finish = event.target.value;
    } else {
      var finish = this.state.reading_finish;
    }
    var delivered = (parseInt(finish) - parseInt(start));
    this.setState({quantity: delivered});
  }
  handleExtraFlightToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = true;
    } else {
      var value = false;
    }
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  handleSelectChangeLeg(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      if(navigator.onLine) {
        var header = this.refs.request_api.header('application/json');
        var self = this;
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/relatorio/voo/trecho/localidade/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({
              locations_select: responseJson.data.locations_select,
              location_id: responseJson.data.flight_report_leg.departure_location_id,
              next_location_id: responseJson.data.flight_report_leg.arrival_location_id,
              reading_start: responseJson.data.flight_report_leg.fuel_start
            });
            self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
  
    }
    this.setState(change);
  }

  handleSelectChangeFuelSupplier(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      if(navigator.onLine) {
        var header = this.refs.request_api.header('application/json');
        var self = this;
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/fornecedor/combustivel/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({
              approval_required: responseJson.data.main.refuel_approval_required,
              export_required: responseJson.data.main.refuel_export_required,
              staff_id: '',
              requested: '',
              receit: '',
              quantity: '',
              address: '',
              fueling_started: '',
              fueling_finished: '',
              next_location_id: '',
              hydrant_no: '',
              your_sale_no: '',
              previous_sale_no: '',
              reading_finish: '',
              reading_start: '',
            });
            self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
        
    }
    this.setState(change);
  }
  handleSelectChangeCompany(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;


      if(navigator.onLine) {
        var header = this.refs.request_api.header('application/json');
        var self = this;
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/empresa/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.setState({
              address: responseJson.data.main.address + ', ' + responseJson.data.main.city + ', ' + responseJson.data.main.province,
            });
            self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
          });
        });
      } else {
        window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
      }
  
    }
    this.setState(change);
  }


  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.fuel_unity === 'undefined' || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        flight_report_id: newProps.flight_report_id,
        fuel_type: newProps.fuel_type,
        fuel_type_id: newProps.fuel_type_id,
        fuel_unity: newProps.fuel_unity,
        flight_report_refuels: newProps.flight_report_refuels,
        flight_report_legs_select: newProps.flight_report_legs_select,
        fuel_suppliers_select: newProps.fuel_suppliers_select,
        companies_select: newProps.companies_select,
        ptbr_fuels_select: newProps.ptbr_fuels_select,
        staffs_select: newProps.staffs_select,
        fuel_types_select: newProps.fuel_types_select,
        loaded: 1,
      });
    }
  }

  autoFillTime (name) {

    var now = moment(new Date());
    now = now.format("HH:mm");
    var change = {};
    change[name] = now;

    this.setState(change);
  }

  // Fetch salvando a edição
  // Fetch salvando a edição
  add(event) {
    event.preventDefault();

    if(navigator.onLine) {
      var datasave = new FormData();
      var imagedata = document.querySelector(".input-nf-file").files[0];
      datasave.append("aircraft_id", this.state.aircraft_id);
      datasave.append("date", this.state.date);
      datasave.append("flight_report_id", this.state.flight_report_id);
      datasave.append("flight_report_leg_id", this.state.flight_report_leg_id);
      datasave.append("fuel_supplier_id", this.state.fuel_supplier_id);
      datasave.append("location_id", this.state.location_id);
      datasave.append("receit", this.state.receit);
      datasave.append("requested", this.state.requested);
      datasave.append("quantity", this.state.quantity);
      datasave.append("file", imagedata);
      datasave.append("address", this.state.address);
      datasave.append("staff_id", this.state.staff_id);
      datasave.append("fueling_started", this.state.fueling_started);
      datasave.append("fueling_finished", this.state.fueling_finished);
      datasave.append("next_location_id", this.state.next_location_id);
      datasave.append("hydrant_no", this.state.hydrant_no);
      datasave.append("your_sale_no", this.state.your_sale_no);
      datasave.append("previous_sale_no", this.state.previous_sale_no);
      datasave.append("reading_finish", this.state.reading_finish);
      datasave.append("reading_start", this.state.reading_start);
      datasave.append("fuel_type_id", this.state.fuel_type_id);
      var header = this.refs.request_api.header();
      var self = this;
      this.props.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/relatorio/voo/abastecimento', {
          method: 'POST',
          mode: 'cors',
          headers: value,
          body: datasave }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            var url = '/abastecimento/editar/' + responseJson.data.flight_report_refuel.id;
            var storage = {
              alert_message: responseJson.message,
              alert_type: responseJson.status,
            };
            localStorage.setItem("verify_message", JSON.stringify(storage));
            self.setState({redirect_url: url});
          }
          self.props.updateData(responseJson);
          self.props.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    } else {
      window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
    }
    
  }

  delete (id) {

    if(navigator.onLine) {
      if (window.confirm(this.locale.RelatorioAbastecimento.AdicionarAbastecimento.deletar)) {
        this.props.handleAlert('', '', 'open');
        var datasave = {
          id: id
        };
        var header = this.refs.request_api.header('application/json');
        var self = this;
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/relatorio/voo/abastecimento', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            self.refs.request_api.validate(responseJson, 'alert');
            self.setState({ 
              aircrafts_select: responseJson.data.infos.aircrafts_select,
              locations_select: responseJson.data.infos.locations_select,
              flight_reports_select: responseJson.data.infos.flight_reports_select,
              flight_report_legs: responseJson.data.infos.flight_report_legs_select,
              flight_report_refuels: responseJson.data.infos.flight_report_refuels_table,
              fuel_suppliers_select: responseJson.data.infos.fuel_suppliers_select,
              fuel_types_select: responseJson.data.infos.fuel_types_select,
              companies_select: responseJson.data.infos.companies_select,
              staffs_select: responseJson.data.infos.staffs_select,
              aircraft_id: '',
              date: '',
              flight_report_leg_id: '',
              fuel_supplier_id: '',
              location_id: '',
              receit: '',
              requested: '',
              quantity: '',
              address: '',
              staff_id: '',
              fueling_started: '',
              fueling_finished: '',
              next_location_id: '',
              hydrant_no: '',
              your_sale_no: '',
              previous_sale_no: '',
              reading_finish: '',
              reading_start: '',
              fuel_type_id: '',
            });
            self.props.updateData(responseJson);
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }).catch((error) => {
            console.error(error);
          });
        });
      }
    } else {
      window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
    }
    
  }

  openEditModal (id) {

    if(navigator.onLine) {
      var self = this;
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/abastecimento/'+ id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'url', '/bases');
          if (responseJson.status === 'success') {
              self.setState({
                  modal_flight_report_refuel_edit: responseJson.data.main,
                  modal_flight_report_legs_select: responseJson.data.flight_report_legs_select,
                  modal_fuel_suppliers_select: responseJson.data.fuel_suppliers_select,
                  modal_aircrafts_select: responseJson.data.aircrafts_select,
                  modal_locations_select: responseJson.data.locations_select,
                  modal_fuel_types_select: responseJson.data.fuel_types_select,
                  modal_companies_select: responseJson.data.companies_select,
                  modal_staffs_select: responseJson.data.staffs_select,
                  flight_report_refuel_approvals: responseJson.data.flight_report_refuel_approvals,
                  modal: true
              });
          }
        }).then(() => {
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        }); /* Overlay */
      });

    } else {
      window.alert(this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.infoOffline);
    }
    
  }

  closeModal(responseJson) {
    this.props.handleAlert('', '', 'open');
    this.setState({
      modal: false,
      flight_report_refuel_edit: {},
    }, this.props.updateData({message: this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.mensagemDadosAtualizadosComSucesso, status: 'success', data: {}}));
  }

  formFields(fields_type) {

    var fields = '';

    if (fields_type == 0) {
      fields = (
        <div className="row">
          <div className="col-md-4 form-group">
              <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.CombustivelSolicitado}:</label>
              <InputMask value={this.state.requested}  maskChar={null} name="requested " mask="9999" className="form-control" onChange={this.handleChange.bind(this, 'requested')} placeholder="" />
          </div>
          <div className="col-md-4 form-group">
              <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.NumeroDaCe}:</label>
              <input type="text" name="receit" className="form-control" placeholder="" value={this.state.receit} onChange={this.handleChange.bind(this, 'receit')} required />
          </div>
          <div className="col-md-4 form-group">
              <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.CombustivelAbastecido}:</label>
              <InputMask value={this.state.quantity}  maskChar={null} name="quantity " mask="9999" className="form-control" onChange={this.handleChange.bind(this, 'quantity')} placeholder="" required/>
          </div>
        </div>
      );
    } else {
      fields = (
        <div>
          <div className="row">
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Endereco}</label>
                <input type="text" name="address" className="form-control" placeholder="" value={this.state.address} onChange={this.handleChange.bind(this, 'address')} required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Comandante}</label>
                <Select
                  className="form-field-name"
                  name="staff_id"
                  value={this.state.staff_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'staff_id')}
                  options={this.state.staffs_select}
                />
            </div>
            <div className="col-md-2 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.InicioAbastecimento}:</label>
                <InputMask value={this.state.fueling_started}  maskChar={null} name="fueling_started " mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'fueling_started')} placeholder="hh:mm" />
            </div>
            <div className="col-md-1 form-group">
              <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Click}</label>
              <button type="button" className="btn btn-primary btn-sm form-control" onClick={() => {this.autoFillTime('fueling_started')}}><i className="fa fa-angle-double-left"></i> <i className="fa fa-fw fa-clock-o"></i></button>
            </div>
            <div className="col-md-2 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.TerminoAbastecimento}:</label>
                <InputMask value={this.state.fueling_finished}  maskChar={null} name="fueling_finished " mask="99:99" className="form-control" onChange={this.handleChange.bind(this, 'fueling_finished')} placeholder="hh:mm" />
            </div>
            <div className="col-md-1 form-group">
              <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Click}</label>
              <button type="button" className="btn btn-primary btn-sm form-control" onClick={() => {this.autoFillTime('fueling_finished')}}><i className="fa fa-angle-double-left"></i> <i className="fa fa-fw fa-clock-o"></i></button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.ProximaLocalidade}:</label>
                <Select
                  className="form-field-name"
                  name="next_location_id"
                  value={this.state.next_location_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChange.bind(this, 'next_location_id')}
                  options={this.state.locations_select}
                  required
                />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.NumeroHidrante}:</label>
                <input type="number" name="hydrant_no" className="form-control" placeholder="999" value={this.state.hydrant_no} onChange={this.handleChange.bind(this, 'hydrant_no')} required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.SeuNumeroDeVenda}:</label>
                <input type="text" name="your_sale_no" className="form-control" placeholder="" value={this.state.your_sale_no} onChange={this.handleChange.bind(this, 'your_sale_no')} required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.NumeroDeVendaAnterior}:</label>
                <input type="text" name="previous_sale_no" className="form-control" placeholder="" value={this.state.previous_sale_no} onChange={this.handleChange.bind(this, 'previous_sale_no')} required />
            </div>
          </div>

          <div className="row">
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.LeituraFinal}:</label>
                <input type="number" name="reading_finish" className="form-control" placeholder="999" value={this.state.reading_finish} onChange={this.handleChangeGallonsReading.bind(this, 'reading_finish')} required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.LeituraInicial}:</label>
                <input type="number" name="reading_start" className="form-control" placeholder="999" value={this.state.reading_start} onChange={this.handleChangeGallonsReading.bind(this, 'reading_start')} required />
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Entregues}:</label>
                <InputMask value={this.state.quantity}  maskChar={null} name="quantity" mask="9999" className="form-control" onChange={this.handleChange.bind(this, 'quantity')} placeholder="9999" required/>
            </div>
            <div className="col-md-3 form-group">
                <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.TipoCombustivel}:</label>
                <Select
                  className="form-field-name"
                  name="fuel_type_id"
                  value={this.state.fuel_type_id}
                  searchable={true}
                  placeholder={'Selecione'}
                  onChange={this.handleSelectChangeFuelType.bind(this, 'fuel_type_id')}
                  options={this.state.fuel_types_select}
                  required
                />
            </div>
          </div>
        </div>
      );
    }

    return fields;

  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloCadastrarAbastecimento}</h3>
  <hr/>
  <form onSubmit={this.add}>
    <div className="row">
      <div className="col-md-6 form-group">
        <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Fornecedor}:</label>
        <Select
          className="form-field-name"
          name="fuel_supplier_id"
          value={this.state.fuel_supplier_id}
          searchable={true}
          placeholder={'Selecione'}
          onChange={this.handleSelectChangeFuelSupplier.bind(this, 'fuel_supplier_id')}
          options={this.state.fuel_suppliers_select}
          required
        />
      </div>
      <div className="col-md-6 form-group">
        <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.AnexarNotaFiscal}:</label>
        <input type="file" name="file" className="form-control input-nf-file" value={this.state.file} onChange={this.handleChange.bind(this, 'file')} />
      </div>
    </div>
    <div className="row">
      <div className="col-md-4 form-group">
        <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Trecho}:</label>
        <Select
            className="form-field-name"
            name="flight_report_leg_id"
            value={this.state.flight_report_leg_id}
            searchable={true}
            placeholder={'Selecione'}
            onChange={this.handleSelectChangeLeg.bind(this, 'flight_report_leg_id')}
            options={this.state.flight_report_legs_select}
            required
        />
      </div>
      <div className="col-md-4 form-group">
        <label>{this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.Localidade}:</label>
        <Select
          className="form-field-name"
          name="location_id"
          value={this.state.location_id}
          searchable={true}
          placeholder={'Selecione'}
          onChange={this.handleSelectChange.bind(this, 'location_id')}
          options={this.state.locations_select}
          required
        />
      </div>
    </div>
    {this.formFields(this.state.export_required)}
    <button type="submit" className="btn btn-primary btn-block btn-inline"><i className="fa fa-fw fa-save"></i> {this.locale.RelatorioAbastecimento.AdicionarAbastecimento.formulario.botaoAdicionarAbastecimento}</button>
  </form>
  <hr/>
  <h4 className="page-title">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloAbastecimentosCadastrados}</h4>
  <hr/>
  <div className="table-responsive">
    <table className="table table-bordered table-hover table-striped">
      <thead>
        <tr>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAbastecimentosCadastrados.Trecho}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAbastecimentosCadastrados.NumeroDaCE}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAbastecimentosCadastrados.Fornecedor}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAbastecimentosCadastrados.Localidade}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAbastecimentosCadastrados.QuantidadeSolicitada}</th>
          <th>{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAbastecimentosCadastrados.QuantidadeAbastecida}</th>
          <th className="col-md-1 text-center">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tabelaAbastecimentosCadastrados.Acoes}</th>
        </tr>
      </thead>
      <tbody>
      {Object.keys(self.state.flight_report_refuels).map(function(k) {
        var srr = self.state.flight_report_refuels[k];
        return (
          <tr key={srr.id}>
            <td>
            {(srr.flight_report_leg === null ) ? '' :
              <span>{srr.flight_report_leg.leg_number}</span>
            }
            </td>
            <td>{srr.receit}</td>

            <td>
            {(srr.fuel_supplier === null ) ? '' :
              <span>{srr.fuel_supplier.name}</span>
            }
            </td>
            <td>
            {(srr.location === null ) ? '' :
              <span>{srr.location.name}</span>
            }
            </td>
            <td>{srr.requested} {self.state.fuel_unity}</td>
            <td>{srr.quantity} L</td>
            <td className="text-center">
              <button onClick={() => self.delete(srr.id)} className="btn btn-danger btn-sm"><i className="fa fa-trash"></i></button>
              <button onClick={() => self.openEditModal(srr.id)} className="btn btn-primary btn-sm"><i className="fa fa-pencil"></i></button>
            </td>
          </tr>
        );
      })}
      </tbody>
    </table>
  </div>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">{this.locale.RelatoriosDeVoo.EditarRelatoriosDeVoo.tituloEditarSolicitacaoDeCombustivel}</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <FlightReportRefuelEditTab updateData={this.props.updateData} handleAlert={this.props.handleAlert} flight_report_refuel_edit={this.state.modal_flight_report_refuel_edit} flight_report_legs_select={this.state.modal_flight_report_legs_select} fuel_suppliers_select={this.state.modal_fuel_suppliers_select} aircrafts_select={this.state.modal_aircrafts_select} locations_select={this.state.modal_locations_select} fuel_types_select={this.state.modal_fuel_types_select} companies_select={this.state.modal_companies_select} staffs_select={this.state.modal_staffs_select}/>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default FlightReportRefuelTab;



// WEBPACK FOOTER //
// ./src/Components/FlightReports/Elements/FlightReportRefuelTab.js